export const ALL_OFFICES = "allOffices";
